import { SiteContextProvider, client } from "@provider";
import { ApolloProvider } from "@apollo/client";
import { ReactNode } from "react";
import { Framework } from "@components";

export const wrapPageElement = ({ element }: { element: ReactNode }) => (
  <ApolloProvider client={client}>
    <SiteContextProvider>
      <Framework>{element}</Framework>
    </SiteContextProvider>
  </ApolloProvider>
);
